/**
 * Whether a pathname belongs to the auth flow (login, password reset, …).
 * Chrome like the sidebar and the ⌘K command bar is hidden there.
 *
 * Uses `includes` rather than `startsWith` because the proxy rewrites
 * `/p/auth/…` to `/{subdomain}/p/auth/…`, so depending on where the pathname
 * comes from (x-pathname header vs. usePathname) it may carry the prefix.
 */
export function isAuthPathname(pathname: string): boolean {
  return pathname.includes("/p/auth/");
}
